module.exports = __webpack_public_path__ + "img/pix.a79adec7.svg";